module.exports = __webpack_public_path__ + "img/5.df921234.png";